import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { MarketExplorerComponent } from './market-explorer.component';

const routes: Routes = [
    {
        path: '', component: MarketExplorerComponent,
        data: {
            metaData: {
                title: 'Explore o mercado | Toro Investimentos',
                metaTags: {
                    description: '',
                },
            },
        },
    },


];

// Exporta apenas a rota configurada.
export const marketExplorerRoutes: ModuleWithProviders = RouterModule.forChild(routes);
